// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum SessionType {
    Full = 0,
    Incremental = 1
}
